import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Container from "react-bootstrap/Container";
// import Stack from "react-bootstrap/Stack";
import { colors, resolveColor } from "utils/styles";
import renderItem from "utils/renderItem";

import LeftRight from "@components/Reusables/LeftRight";
/**
 * Build with LeftRight component, but adds an offset to the left side column
 * Often used three times with alternating left right (text/img) views
 *
 * @param {reverse} Boolean renders left on the right, and right on the left
 * @param {topSide} React component that is rendered above left and right columns
 * @param {leftSide} React component that is rendered in the left column
 * @param {rightSide} React component that is rendered in the right column
 * @returns
 */
export default function LeftRightOffset(props) {
	const fields = props.data?.fields;
	const sectionIndex = props.sectionIndex;

	const topPadding = fields?.topPadding !== undefined ? fields?.topPadding : 3;
	const bottomPadding = fields?.bottomPadding !== undefined ? fields?.bottomPadding : 3;
	const reverse = fields?.reverse;
	const leftSideOffset = fields?.leftSideOffset;
	const leftSideClasses = fields?.leftSideClasses || "";
	const rightSideClasses = fields?.rightSideClasses || "";
	const columnReverse = fields?.columnReverse || "";

	const leftSideVerticalAlign = fields?.leftSideVerticalAlign || "center";
	const rightSideVerticalAlign = fields?.rightSideVerticalAlign || "center";

	const xsCol = 11;
	const smCol = 11;
	const mdCol = 11;
	const lgCol = 12;

	const leftSideInnerBreakpoints = fields?.leftSideInnerBreakpoints;
	const rightSideInnerBreakpoints = fields?.rightSideInnerBreakpoints;

	const ls = {
		xsCol: leftSideInnerBreakpoints?.xs || 11,
		smCol: leftSideInnerBreakpoints?.sm || 11,
		mdCol: leftSideInnerBreakpoints?.md || 11,
		lgCol: leftSideInnerBreakpoints?.lg || 12,
	};
	const rs = {
		xsCol: rightSideInnerBreakpoints?.xs || 11,
		smCol: rightSideInnerBreakpoints?.sm || 11,
		mdCol: rightSideInnerBreakpoints?.md || 11,
		lgCol: rightSideInnerBreakpoints?.lg || 12,
	};

	const reverseAndOffset = reverse && leftSideOffset;
	const onlyReverse = reverse && !leftSideOffset;
	const onlyOffset = !reverse && leftSideOffset;
	const notReverseNoOffset = !reverse && !leftSideOffset;
	const hashLink = fields?.hashLink;

	return (
		<div id={hashLink} className="SingleColumnTextAndImage">
			<LeftRight
				leftCol={fields?.leftColumnWidth}
				rightCol={fields?.rightColumnWidth}
				outerBgColor={colors[fields?.backgroundColor?.fields?.color]}
				leftBgColor={colors[fields?.leftBackgroundColor?.fields?.color]}
				rightBgColor={colors[fields?.rightBackgroundColor?.fields?.color]}
				reverse={reverse}
				topPadding={topPadding}
				bottomPadding={bottomPadding}
				leftSideVerticalAlign={leftSideVerticalAlign}
				rightSideVerticalAlign={rightSideVerticalAlign}
				columnReverse={columnReverse}
				leftSide={
					<div className={`row g-0 flex-row leftSideSingleColText d-flex ${leftSideClasses} w-100`}>
						{/* <Row className={` g-0    flex-row`}> */}
						<Col
							xs={{ offset: reverse ? 0 : leftSideOffset ? 0 : 0, span: 12 }}
							lg={{
								offset: reverseAndOffset ? 1 : onlyOffset ? 1 : onlyReverse ? 1 : 0,
								span: reverseAndOffset ? 10 : onlyOffset ? 10 : 11,
							}}
							xl={{
								offset: reverseAndOffset ? 2 : onlyOffset ? 1 : onlyReverse ? 1 : 0,
								span: reverseAndOffset ? 9 : onlyOffset ? 11 : 11,
							}}
							xxl={{
								offset: reverseAndOffset ? 1 : onlyOffset ? 1 : onlyReverse ? 1 : 0,
								span: reverseAndOffset ? 10 : onlyOffset ? 11 : 11,
							}}
						>
							<Row className="g-0 justify-content-center justify-content-lg-start">
								<Col className="" xs={ls.xsCol} sm={ls.smCol} md={ls.mdCol} lg={ls.lgCol}>
									{/* Rendering a list of components */}
									{fields?.leftSideComponents &&
										fields?.leftSideComponents.map((component) => (
											<React.Fragment key={component.sys.id}>
												{renderItem(component, sectionIndex)}
											</React.Fragment>
										))}
								</Col>
							</Row>
						</Col>
						{/* </Row> */}
					</div>
				}
				rightSide={
					<Row className={`g-0 justify-content-center justify-content-lg-${reverse ? "start" : "end"} w-100`}>
						<Col className="" xs={rs.xsCol} sm={rs.smCol} md={rs.mdCol} lg={rs.lgCol}>
							<div className={`rightSide ${rightSideClasses} w-100`}>
								{fields?.rightSideComponents &&
									fields?.rightSideComponents.map((component) => (
										<React.Fragment key={component.sys.id}>
											{renderItem(component, sectionIndex)}
										</React.Fragment>
									))}
							</div>
						</Col>
					</Row>
				}
				bottomCenter={fields?.bottomCenter}
			/>
			<style jsx="true">{`
				.leftSideSingleColText {
				}

				.rightSide {
				}
			`}</style>
		</div>
	);
}
